import { render, staticRenderFns } from "./AddUpdateModule.html?vue&type=template&id=6c560902&scoped=true&"
import script from "./AddUpdateModule.vue?vue&type=script&lang=js&"
export * from "./AddUpdateModule.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateModule.vue?vue&type=style&index=0&id=6c560902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c560902",
  null
  
)

export default component.exports